export default __webpack_public_path__ + "static/media/TikTok.1f7944c9.png";